import { render, staticRenderFns } from "./UnitAirVolumesComponent.vue?vue&type=template&id=dedd4770&"
import script from "./UnitAirVolumesComponent.vue?vue&type=script&lang=js&"
export * from "./UnitAirVolumesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports